// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"1fdea71f","513":"8efc7b32","703":"4f23c3a1","787":"4e5f82b1"}[chunkId] + ".chunk.js";
};